import NotificationCenter from './NotificationCenter.container'

export default NotificationCenter
